import React from 'react';
import './Searchnav.css';
import WelcomeName from './WelcomeName';
function Searchnav() {
    return (
        <>
            <div class="searchnav-container">
                <div class="searchnav-wrap">
                    <div class="searchnav-row">
                        <div class="searchnav-box" style={{ textAlign: 'left', marginTop: '5px' }}>
                            <img src={process.env.PUBLIC_URL + "/images/Acc_Logo_Black_Purple_RGB.png"} class="acc-logo" alt="logo" />
                            <p class="desktop-tag"><a href="https://atci.lkm.accenture.com/newhome"> Learning & Talent Transformation, ATCI</a></p>
                            <p class="mobile-tag"><a href="https://atci.lkm.accenture.com/newhome"> L&TT</a></p>
                        </div>
                    </div>
                    <div class="searchnav-row">
                        <div class="searchnav-box" style={{ textAlign: 'right', marginTop: '5px' }}>
                            <WelcomeName />
                            {/* <div className="tooltips">
                                <img src="images/Avatar.png" class="user-img" alt="user-image" />
                                <span class="tooltiptext first">Avatar</span>
                            </div> */}
                            <img src={process.env.PUBLIC_URL + "/images/Avatar.png"} class="user-img" alt="user-image" />
                            {/* <div className="tooltips">
                                <img src={process.env.PUBLIC_URL + "/images/Home/Search-icon.png"} class="all-three-icons" alt="user-image" />
                                <span class="tooltiptext">Search</span>
                            </div>
                            <div className="tooltips">
                                <img src={process.env.PUBLIC_URL + "/images/Home/subscription-icon.png"} class="all-three-icons" alt="user-image" />
                                <span class="tooltiptext">Subscribe button</span>
                            </div>
                            <div className="tooltips">
                                <img src={process.env.PUBLIC_URL + "/images/Home/Accessibility-icon.png"} style={{ marginRight: '0px' }} class="all-three-icons" alt="user-image" />
                                <span class="tooltiptext last">Accessibility</span>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Searchnav
